import Vue from 'vue'
import VueRouter from 'vue-router'
import Overview from '@/views/Overview'
import { manageGuard, supporterGuard, signupGuard } from './guards'
import { multiGuard, auth0Guard } from '@my-prtg-com/shared/src/router'

Vue.use(VueRouter)

const routes = [
  // always redirect to root for non-existing paths
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/',
    name: 'Overview',
    component: Overview,
    beforeEnter: auth0Guard,
  },
  {
    path: '/signup',
    name: 'SignUp',
    beforeEnter: signupGuard,
  },
  {
    path: '/new',
    name: 'New',
    component: () => import(/* webpackChunkName: "new" */ '@/views/New'),
    beforeEnter: auth0Guard,
  },
  {
    path: '/manage/:id',
    name: 'Manage',
    component: () => import(/* webpackChunkName: "subscription" */ '@/views/Manage'),
    props: ({ params }) => ({ id: params.id, scrollToSubscription: params.scrollToSubscription }),
    beforeEnter: multiGuard([auth0Guard, manageGuard]),
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "account" */ '@my-prtg-com/shared/src/views/Account'),
    beforeEnter: auth0Guard,
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: () => import(/* webpackChunkName: "invoice" */ '@/views/Invoice'),
    beforeEnter: auth0Guard,
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import(/* webpackChunkName: "support" */ '@/views/Support'),
    beforeEnter: multiGuard([auth0Guard, supporterGuard]),
  },
  {
    path: '/rollouts',
    name: 'Rollouts',
    component: () => import(/* webpackChunkName: "rollouts" */ '@/views/Rollouts'),
    beforeEnter: multiGuard([auth0Guard, supporterGuard]),
  },
  {
    path: '/support/faq',
    name: 'SupportFaq',
    component: () => import(/* webpackChunkName: "support" */ '@/views/SupportFaq'),
    beforeEnter: multiGuard([auth0Guard, supporterGuard]),
  },
  {
    path: '/upload',
    name: 'UploadSelect',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/SubscriptionSelectSkeleton'),
    props: () => ({
      icon: '$mdiFileUpload',
      header: 'file upload',
    }),
    beforeEnter: auth0Guard,
    children: [
      {
        path: ':id',
        name: 'Upload',
        props: ({ params }) => ({ id: params.id }),
        component: () => import(/* webpackChunkName: "settings" */ '@/views/InstanceProgressSkeleton'),
        beforeEnter: manageGuard,
        children: [
          {
            path: 'default',
            component: () => import(/* webpackChunkName: "upload" */ '@/views/Upload'),
            alias: '',
            props: ({ params }) => ({ id: params.id }),
          },
        ],
      },
    ],
  },
  {
    path: '/microsoft-entra-id',
    name: 'MicrosoftEntraIdSelect',
    component: () => import(/* webpackChunkName: "settings" */ '@/views/SubscriptionSelectSkeleton'),
    props: () => ({
      icon: '$mdiMicrosoftWindows',
      header: 'microsoft entra ID',
    }),
    beforeEnter: auth0Guard,
    children: [
      {
        path: ':id',
        name: 'MicrosoftEntraId',
        props: ({ params }) => ({ id: params.id }),
        component: () => import(/* webpackChunkName: "settings" */ '@/views/InstanceProgressSkeleton'),
        beforeEnter: manageGuard,
        children: [
          {
            path: 'default',
            component: () => import(/* webpackChunkName: "azure" */ '@/views/MicrosoftEntraId'),
            alias: '',
            props: ({ params }) => ({ id: params.id }),
          },
        ],
      },
    ],
  },
  {
    path: '/data-sharing-opt-in',
    name: 'DataCollectionOptIn',
    component: () => import(/* webpackChunkName: "cia" */ '@/views/DataCollectionOptIn'),
    beforeEnter: auth0Guard,
  },
]

const scrollBehavior = () => new Promise(resolve => {
  setTimeout(() => {
    resolve({ x: 0, y: 0 })
  }, 250)
})

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior,
})

export default router
export {
  routes,
  scrollBehavior,
}
export * from './guards'
